import axios from "axios";

export const getProfessionalTournament = async (id, token) => {
  //   "";
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getProfessionalTournament/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
